import viewerTemplateScroll from './viewer-template-scroll';

const viewerTemplate = (list) =>{
    return `<div class="pswp">
                <div class="pswp__bg"></div>
                <div class="pswp__scroll-wrap">
                    <div class="pswp__container">
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                    </div>
                    
                    <div class="pswp__ui pswp__ui--hidden">
                        <div class="pswp__counter"></div>
                        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                        <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
                        <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
                        <a href="" download class="pswp__button pswp__button--download">다운로드</a>
                        <div class="pswp__caption">
                            <div class="pswp__caption__center"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pswp-navi">
                <div class="pswp-navi__list">
                    <div class="scroller">
                        ${viewerTemplateScroll(list)}
                    </div>
                </div>
            </div>
    `;
};

export default viewerTemplate;